import type { PushedJob } from "../types/jobs.types";

type JobDataListener = (pushedJobs: Map<string, PushedJob>, lastPushedJob: PushedJob | null) => void;

class JobDataManager {
  private pushedJobs: Map<string, PushedJob> = new Map();
  private lastPushedJob: PushedJob | null = null;
  private listeners: Set<JobDataListener> = new Set();

  subscribe(listener: JobDataListener): () => void {
    this.listeners.add(listener);
    // Immediately call with current data
    listener(this.pushedJobs, this.lastPushedJob);

    return () => {
      this.listeners.delete(listener);
    };
  }

  updateJobs(pushedJobs: Map<string, PushedJob>, lastPushedJob: PushedJob | null) {
    this.pushedJobs = pushedJobs;
    this.lastPushedJob = lastPushedJob;

    // Notify all listeners
    this.listeners.forEach((listener) => {
      listener(this.pushedJobs, this.lastPushedJob);
    });
  }

  getPushedJob(jobUuid: string): PushedJob | null {
    return this.pushedJobs.get(jobUuid) ?? null;
  }

  getPushedJobs(): Map<string, PushedJob> {
    return this.pushedJobs;
  }

  getLastPushedJob(): PushedJob | null {
    return this.lastPushedJob;
  }
}

export const jobDataManager = new JobDataManager();
